module.exports = "/fonts/vendor/boxicons/boxicons.ttf?db9ddb1898dbd76badca2274342644cc";